<template>
    <div id="data-list-list-view" class="bg-white p-8 rounded-lg shadow-md data-list-container">
        <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="addNewDataSidebar = false"
            :title="titleSideBar">
            <formEditar slot="form" @cancel="addNewDataSidebar = false" @concluido="onConcluido" :sideBar="true"
                :dados="dadosSideBar" :contadorRender="contadorRender" />
        </add-new-data-sidebar>

        <vs-table noDataText="Nenhum item no shopping" ref="table" multiple v-model="selected" pagination
            :max-items="itemsPerPage" search :data="itens" class="tablePrincipal">
            <div slot="header" class="flex flex-wrap-reverse items-center justify-between mb-4">
                <div class="flex items-center">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                        <div
                            class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
                            <span class="mr-2">Ações</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="deletar">
                                <span>Deletar</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="imprimir">
                                <span>Imprimir</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item>
                                <span>
                                    <downloadexcel :data="selected" :fields="colunas" name="Produtos.xls" type="xls">
                                        Exportar
                                    </downloadexcel>
                                </span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">
                            {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                            {{
                                itens.length - currentPage * itemsPerPage > 0
                                    ? currentPage * itemsPerPage
                                    : itens.length
                            }}
                            de {{ itens.length }}
                        </span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage = 5">
                            <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 25">
                            <span>25</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 50">
                            <span>50</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th>SKU</vs-th>
                <vs-th>Nome</vs-th>
                <vs-th>Categoria</vs-th>
                <vs-th>Coins</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Ações</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr v-for="item in data" :key="item.idProdutoShopping" :data="item">
                        <vs-td>{{ item.idProdutoShopping }}</vs-td>
                        <vs-td>{{ item.produto.sku }}</vs-td>
                        <vs-td>{{ item.produto.nomeProduto }}</vs-td>
                        <vs-td>
                            <span v-if="!item.produto.categorias.length">–</span>
                            <span v-else>
                                {{item.produto.categorias.map(c => c.nome).join(', ')}}
                            </span>
                        </vs-td>
                        <vs-td>{{ item.valorVenda.toFixed(2) }}</vs-td>
                        <vs-td>
                            <vs-chip :color="item.status ? 'success' : 'danger'">
                                {{ item.status ? 'Ativo' : 'Inativo' }}
                            </vs-chip>
                        </vs-td>
                        <vs-td>
                            <vs-button class="d-inline" icon-pack="feather" color="success" icon="icon-edit"
                                @click="openSideBar(item)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
import AddNewDataSidebar from "@/views/Includes/SideBar.vue";
import formEditar from "./FormShopping.vue";
import service from "@/services";
import downloadexcel from "vue-json-excel";
import jwt from "jsonwebtoken";

export default {
    components: {
        AddNewDataSidebar,
        formEditar,
        downloadexcel,
    },
    data() {
        return {
            decoded: service.getDecoded(),
            itens: [],
            selected: [],
            colunas: {
                idProdutoShopping: "#",
                "produto.sku": "SKU",
                "produto.nomeProduto": "Nome",
                categoria: "Categoria",
                valorVenda: "Valor",
                status: "Status",
            },
            itemsPerPage: 10,
            currentFilter: "ativo",
            addNewDataSidebar: false,
            dadosSideBar: null,
            contadorRender: 0,
        };
    },
    computed: {
        currentFilterLabel() {
            return this.currentFilter === "ativo"
                ? "Ativos"
                : this.currentFilter === "inativo"
                    ? "Inativos"
                    : "Todos";
        },
        currentPage() {
            if (this.isMounted && this.$refs.table && this.$refs.table.currentx) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },
    methods: {
        async buscaDados(filtro) {
            console.log("[buscaDados] filtro recebido:", filtro);
            this.currentFilter = filtro;
            this.$vs.loading();
            const status =
                filtro === "inativo" ? false :
                    filtro === "todos" ? undefined :
                        true;
            console.log("[buscaDados] status enviado ao back:", status);

            try {
                const res = await service.post("ProdutosShopping", "Listar", { status });
                console.log("[buscaDados] resposta do backend:", res);
                console.log("[buscaDados] res.data:", res.data);
                this.itens = res.data;
                console.log("[buscaDados] this.itens após atribuir:", this.itens);
            }
            catch {
                this.$vs.notify({ title: "Erro", text: "Falha ao buscar", color: "danger" });
            } finally {
                this.$vs.loading.close();
            }
        },
        async onConcluido() {
            this.addNewDataSidebar = false;
            await this.buscaDados(this.currentFilter);
        },
        openSideBar(item) {
            this.dadosSideBar = item;
            this.addNewDataSidebar = true;
            this.contadorRender++;
        },
        async deletar() {
            if (this.selected.length === 0) {
                this.$vs.notify({
                    title: 'Aviso',
                    text: 'Selecione ao menos um produto para deletar.',
                    color: 'warning',
                    position: 'top-center'
                });
                return;
            }

            if (!confirm(`Tem certeza que deseja deletar ${this.selected.length} produto(s)?`)) {
                return;
            }

            try {
                this.$vs.loading();
                for (const item of this.selected) {
                    await service.put('ProdutosShopping', 'Deletar', { idProdutoShopping: item.idProdutoShopping });
                }

                this.$vs.notify({
                    title: 'Sucesso',
                    text: 'Produto(s) deletado(s) com sucesso.',
                    color: 'success',
                    position: 'top-center'
                });

                await this.buscaDados(this.currentFilter);
                this.selected = [];

            } catch (error) {
                console.error(error);
                this.$vs.notify({
                    title: 'Erro',
                    text: error.errorMessage || 'Falha ao deletar produto(s).',
                    color: 'danger',
                    position: 'top-center'
                });
            } finally {
                this.$vs.loading.close();
            }
        },
        imprimir() {
            setTimeout(() => window.print(), 500);
        },
    },
    created() {
        console.log("[created] componente criado, itens iniciais:", this.itens);
        this.buscaDados("ativo");
    }
};
</script>

<style lang="scss">
@media print {
    #content-area {
        margin-left: 0px;
    }

    .navbar-sticky .router-view .router-content {
        margin-top: 0px;
    }

    .vs-content-sidebar,
    .con-pagination-table,
    div#data-list-list-view .vs-con-table .vs-table--header,
    .the-footer,
    .vs-navbar {
        display: none !important;
    }

    body,
    .vs-con-table .vs-con-tbody {
        background-color: #ffffff;
    }

    .vx-card,
    #data-list-list-view .vs-con-table .vs-table tr {
        box-shadow: none !important;
    }

    .td-check {
        visibility: hidden;
    }
}

#data-list-list-view {
    .vs-con-table {
        .vs-table--header {
            display: flex;
            flex-wrap: wrap-reverse;
            margin-left: 1.5rem;
            margin-right: 1.5rem;

            >span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    &+i {
                        left: 1rem;
                    }

                    &:focus+i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

                td {
                    padding: 20px;

                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }

                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }

                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }

            th.td-check {
                padding: 0 15px !important;
            }

            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }
    }
}
</style>
